import React, { useContext, useEffect, useState } from 'react'
import Keyboard from 'react-simple-keyboard'
import { MathFieldContext } from './mathInput/mathfieldContext'
import $ from 'jquery'

function NumericKeyboard({
  keyboard,
  numericLayout,
  onChange,
  onKeyPress,
  display,
}) {
  const mathfield = useContext(MathFieldContext)

  useEffect(() => {
    if (mathfield && typeof mathfield.focus === 'function') {
      $(`#mq-keyboard-def-${mathfield.id}`).css('bottom', `0px`)
    }
  }, [mathfield])

  const onMouseDown = (e) => {
    if (e.target instanceof HTMLElement && e.target.nodeName !== 'SELECT') {
      e.preventDefault()
      if (mathfield && typeof mathfield.focus === 'function') {
        mathfield.focus()
      }
    }
  }

  return (
    <React.Fragment>
      <div
        id={`mq-keyboard-num-${mathfield.id}`}
        onMouseDown={onMouseDown}
        className="col-span-1 sm:col-span-1 lg:col-span-1 bg-white ms-0 pe-0 me-[2px]"
      >
        <Keyboard
          baseClass={'bg-white'}
          keyboardRef={(r) => (keyboard.current = r)}
          layout={numericLayout}
          onChange={onChange}
          onKeyPress={onKeyPress}
          display={display}
          physicalKeyboardHighlight={true}
          syncInstanceInputs={false}
          mergeDisplay={true}
          debug={false}
          buttonTheme={[
            {
              class: 'w-[64px]',
              buttons: '0',
            },
            {
              class: 'border-[1px] border-v8-line pb-2',
              buttons:
                '1 2 3 {arrowup} 4 5 6 {arrowdown} 7 8 9 {arrowright} 0 . {arrowleft} ! / # $ % ^ & * ( {shift} ) + {bksp}',
            },
            {
              class: `bg-[url('/images/arrowup.png')] bg-no-repeat bg-center v-none`,
              buttons: '{arrowup}',
            },
            {
              class: `bg-[url('/images/arrowdown.png')] bg-no-repeat bg-center v-none`,
              buttons: '{arrowdown}',
            },
            {
              class: `bg-[url('/images/arrowright.png')] bg-no-repeat bg-center v-none`,
              buttons: '{arrowright}',
            },
            {
              class: `bg-[url('/images/arrowleft.png')] bg-no-repeat bg-center v-none`,
              buttons: '{arrowleft}',
            },
            {
              class: `w-[20px]`,
              buttons: '{arrowleft} {arrowright}',
            },
          ]}
        />
      </div>
    </React.Fragment>
  )
}

export default NumericKeyboard
